import React, { FC } from 'react';
import { LoadingPage } from '../../../Shared/components/Loading';
import { useAuth0 } from '../AuthProvider';

export const Logout: FC = () => {
  const { logout } = useAuth0();
  logout();

  return <LoadingPage />;
};
